module.exports = __webpack_public_path__ + "img/w3_startspinner_dots.cf64715c.png";